<div class="question-card">
	<div class="position-relative">
		<div class="header">
			<vb-profile-picture [profileUrl]="question.anonymous ? null : question.askedBy?.profileImageUri">
			</vb-profile-picture>
			
			<div class="meta">
				@if (question.anonymous) {
					<span class="author">{{ 'Event_QuestionAnonymous' | translate }}</span>
				} @else {
					<span class="author">
						{{ question.askedByFullName }}
						@if (question.isModerator) {
							<span class="moderator-label">{{ 'Event_QA_ModeratorLabel' | translate }}</span>
						}
					</span>
				}
				<span class="question-number-label">{{ 'Event_QuestionNumber' | translate : { '0': question.questionNumber } }}</span>
			</div>

			@if (allowReordering) {
				<div class="drag-handle">
					<span class="glyphicons show_lines"></span>
				</div>
			}

			@if (canModerate && question.isClosed) {
				<div dropdown vbDropdown class="menu-wrapper">
					<button dropdownToggle class="icon-btn" [attr.aria-label]="'Event_QA_ClosedMenu' | translate" [id]="'qaCardMenuBtn' + cardIndex" [attr.aria-controls]="'qaCardMenu' + cardIndex">
						<span class="dot"></span><span class="dot"></span><span class="dot"></span>
					</button>
					<div *dropdownMenu class="dropdown dropdown-menu dropdown-menu-right" role="menu" [id]="'qaCardMenu' + cardIndex" [attr.aria-labelledby]="'qaCardMenuBtn' + cardIndex">
						<button type="button" class="dropdown-item" (click)="addToQueue()">
							{{ 'Event_QA_Action_Queue' | translate }}
						</button>
						@if (!question.isAnswered) {
							<button type="button" class="dropdown-item" (click)="answered()">
								{{ 'Event_QA_Action_MarkAsAnswered' | translate }}
							</button>
						}
						@if (!question.isFollowUp) {
							<button type="button" class="dropdown-item" (click)="followUp()">
								{{ 'Event_QA_Action_Followup' | translate }}
							</button>
						}
						<button type="button" class="dropdown-item" (click)="directReply()">
							{{ 'Event_QA_Action_Reply' | translate }}
						</button>
						@if (question.isQueued) {
							<button type="button" class="dropdown-item" (click)="decline()">
								{{ 'Event_QA_Action_Decline' | translate }}
							</button>
						}
					</div>
				</div>
			}
		</div>
		<p class="question-text manage-question-text" [innerHTML]="question.questionText | safeHtml"></p>
		@if (canModerate && question.isClosed) {
			<div class="action-mark">
				@if (question.isPublic) {
					<span class="vb-icon vb-icon-group-nofill theme-primary-txt"></span>	
				}
				@if (!question.lastAction) {
					<span class="glyphicons remove"></span>
					{{ 'Event_QA_MarkedAsClosed' | translate }}
				} @else if (question.isFollowUp) {
					<span class="glyphicons flag"></span>
					{{ 'Event_QA_MarkedAsFollowUp' | translate }}
				} @else if (question.isAnswered) {
					<span class="glyphicons ok_2"></span>
					{{ 'Event_QA_MarkedAsAnswered' | translate }}
				} @else if (question.isDirectReplied) {
					<span class="vb-icon vb-icon-reply"></span>
					{{ 'Event_QA_MarkedAsReplied' | translate }}
				} @else if (question.isDeclined) {
					<span class="glyphicons remove"></span>
					{{ 'Event_QA_MarkedAsDeclined' | translate }}
				}
			</div>
		
		}
		<div *ngIf="question.replyText && question.repliedBy" class="question-reply">
			<div class="question-reply-header">
				<div class="question-reply-avatar">
					<vb-profile-picture [profileUrl]="question.repliedBy.profileImageUri">
					</vb-profile-picture>
					
				</div>
				<div class="question-reply-meta">
					<span class="question-reply-author">{{question.repliedBy.firstName}} {{question.repliedBy.lastName}}</span>
				</div>
			</div>
			<p class="question-reply-text" [innerHTML]="question.replyText | safeHtml"></p>
		</div>
	</div>
	@if (canModerate && (question.isInbox || question.isQueued)) {
		<div class="question-actions">
			@if (question.isInbox) {
				<button type="button" vbBtnSecondary (click)="close()">
					{{ 'Event_QA_Action_Close' | translate }}
				</button>
			} @else if (question.isQueued) {
				<button type="button" vbBtnSecondary (click)="decline()">
					{{ 'Event_QA_Action_Decline' | translate }}
				</button>
			}

			<button type="button" vbBtnSecondary (click)="followUp()">
				{{ 'Event_QA_Action_Followup' | translate }}
			</button>
			
			@if (question.isInbox) {
				<button type="button" vbBtnSecondary (click)="addToQueue()">
					{{ 'Event_QA_Action_Queue' | translate }}
				</button>
			} @else if (question.isQueued) {
				<button type="button" vbBtnSecondary (click)="answered()">
					{{ 'Event_QA_Action_MarkAsAnswered' | translate }}
				</button>
			}
			<button type="button" vbBtnPrimary (click)="directReply()">
				{{ 'Event_QA_Action_Reply' | translate }}
			</button>
		</div>
		
		@if (canModerate && question.isDirectReplyInProgress) {
			<div class="action-message">
				@if (question.directReplyInProgressBy) {
					<span [hidden]="!question.directReplyInProgressBy">
						{{ 'Event_QA_ReplyInProgressStatusWithName' | translate : { '0': question.directReplyInProgressBy.fullName } }}
					</span>
				} @else {
					<span [hidden]="question.directReplyInProgressBy">
						{{ 'Event_QA_ReplyInProgressStatus' | translate }}
					</span>
				}
			</div>
		}
	}
</div>

<vb-confirmation-dialog [title]="'Event_QA_ReplyConflictingAction_Title' | translate" [message]="'Event_QA_ReplyConflictingAction_Message' | translate" [cancelText]="'No' | translate" [actionText]="'Yes' | translate" [themed]="true">
</vb-confirmation-dialog>
